<script lang="ts">
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import InlineInfoAboutExpiredAccount from '../../shared/InlineInfoAboutExpiredAccount.svelte';
    import { FriendlyDateGenerator } from '../../utilities/FriendlyDateGenerator';
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import { AccountApp } from '../Accounts/AccountApp';
    import SettingsRow from './SettingsRow.svelte';
    import { Account } from '../Accounts/Account';
    import { api } from '../../../stores/api';
    import { debug } from '../../../stores/store';

    let account: Account | null = null;
    let ap: AccountApp = new AccountApp(true);
    let friendlyDate: FriendlyDateGenerator | null;
    let showRelativeToday: boolean = true;

    onMount(() => {
        (async () => {
            await ap.prepareData(get(api));
            account = (await ap.getAllItems())[0] ?? null;
            if (account?.getExpirationDate()) {
                friendlyDate = new FriendlyDateGenerator(
                    account?.getExpirationDate(),
                    showRelativeToday
                );
            } else {
                friendlyDate = null;
            }
        })();
    });
</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('Account')}</div>
    <div slot="content">
        {#if account && account.isExpired() === true}
            <InlineInfoAboutExpiredAccount center={false} />
        {/if}
<!--        <SettingsRow>-->
<!--            <SettingsRowLabel>-->
<!--                {$_('Account type')}-->
<!--            </SettingsRowLabel>-->
<!--            <SettingsRowValue>-->
<!--                <div class="dont-break">-->
<!--                    {#if account && $_(account.getType())}-->
<!--                        {account && $_(account.getType())}-->
<!--                    {:else}-->
<!--                        -&#45;&#45;-->
<!--                    {/if}-->
<!--                </div>-->
<!--            </SettingsRowValue>-->
<!--        </SettingsRow>-->
        <SettingsRow>
            <SettingsRowLabel>
                {$_('Account expiration date')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <div class="dont-break">
                    {#if account}
                        {#if account.getExpirationDate() === null || friendlyDate === null}
                            {$_('bezterminowo')}
                        {:else}
                            {friendlyDate.getYYYYMMDD()}
                        {/if}
                    {/if}
                </div>
            </SettingsRowValue>
        </SettingsRow>
        {#if $debug}
            <SettingsRow>
                <SettingsRowLabel>Customer Id</SettingsRowLabel>
                <SettingsRowValue>
                    {account?.getCustomerId() ?? '---'}
                </SettingsRowValue>
            </SettingsRow>
            <SettingsRow>
                <SettingsRowLabel>Webuser Id</SettingsRowLabel>
                <SettingsRowValue>
                    {account?.getWebuserId() ?? '---'}
                </SettingsRowValue>
            </SettingsRow>
            <SettingsRow>
                {$_('template_dev_reference')}
                <!--

                * dla konta template (#69):
                    * weź customer_id, email i hasło
                        * w tabeli customer_config.settings->is_template:true

                * dla konta zwykłego, które będzie korzystać z template (#70):
                    * utwórz konto w zakładce Customers w panelu admina i zapamiętaj customer_id, webuser_id, np. 70, demo1...@automapa.pl, demo123
                    * w tabeli customer_config.settings->admin:{"template_id": <template-customer-id>, "template_data": "<template-email>:<template-hasło>", "show_data_reset_button": true}
                    * w tabeli lm_user->is_admin:true (szukaj wg webuser_id dla konta zwykłego)

                -->
            </SettingsRow>
        {/if}
    </div>
</TemplateSettingsGeneral>

<style>
    :root {
        --font-size: 15px;
        --chevron-width: 20px;
        --chevron-height: 20px;
    }
    :global(.svelte-select) {
        border-radius: 0 !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #bababa !important;
        min-height: 30px !important;
        padding: 0 0 0 5px !important;
    }
    :global(.list-item .item) {
        padding: 0 !important;
    }
    :global(.value-container) {
        padding: 0 !important;
    }
</style>
